import Money from "./lib/odd-money";
export default Money;